import { useEffect, useState } from "react"
import { useLocalStorage } from "@mantine/hooks"
import { useTranslation } from "react-i18next"
import { Card } from "@vesatogo/grass-core"
import {
  Particulars,
  UserCopy,
  TradeValidity,
  Expenses,
  Facilitator,
  TradeTC,
} from "./details/index"
import { Note, AgreeTerms } from "../components/index"
import { StickyFooter } from "./details/StickyFooter"
import {
  usePavtiTradeDetailQuery,
  useTradeDetailsSubscription,
  VerifyTradeOtp,
} from "../../../generated/graphql"
import { IOTPProps } from "../lib/types"
import { getHashValue, switchUserType } from "../lib/utils"
import { TradeStatus } from "./details/TradeStatus"
import receiptIcon from "../assets/receipt.svg"
import { useClient } from "../../../services/urql.service"
import { Warning } from "phosphor-react"

export function Details({ token, setTitle, page, setPage }: IOTPProps) {
  const { t } = useTranslation()
  const [acceptTc, setAcceptTc] = useState(true)
  const [, setLocalValue] = useLocalStorage<VerifyTradeOtp>({
    key: `${token}`,
  })
  const { resetClient } = useClient()

  const hashValue = getHashValue(token)
  const [{ data }] = usePavtiTradeDetailQuery({
    variables: { id: hashValue?.tradeId },
  })
  const [{ data: subscription, error }] = useTradeDetailsSubscription({
    variables: { id: hashValue?.tradeId },
  })

  useEffect(() => {
    if (error) {
      setLocalValue({})
      setTitle && setTitle("")
      setPage && setPage(1)
      resetClient()
    }
  }, [error])

  useEffect(() => {
    if (setTitle && data) {
      setTitle(
        data?.trade_by_pk?.kind === "final"
          ? "permanent.trade"
          : "temporary.trade"
      )
    }
  }, [data?.trade_by_pk?.kind])

  return data && hashValue ? (
    <>
      <TradeStatus data={subscription?.trade_by_pk} />
      <Facilitator data={data.trade_by_pk} />
      <Note
        text={`${t("receipt.title")}: ${data.trade_by_pk?.id}`}
        icon={receiptIcon as unknown as string}
      />
      <Card className="overflow-hidden !rounded-lg">
        <UserCopy
          data={data.trade_by_pk}
          userType={switchUserType(hashValue?.userType, page === 1)}
        />
        <Particulars data={data.trade_by_pk} />
        <Expenses
          data={data.trade_by_pk}
          userType={switchUserType(hashValue?.userType, page === 1)}
        />
      </Card>
      <TradeValidity data={data.trade_by_pk} />
      <TradeTC
        data={data.trade_by_pk}
        userType={switchUserType(hashValue?.userType, page === 1)}
      />
      <Card className="overflow-hidden mt-4 !rounded-lg">
        {data?.trade_by_pk?.kind !== "final" ? (
          <Note text={t("subject.to.change")} icon={<Warning size={20} />} />
        ) : null}
      </Card>
      <AgreeTerms value={acceptTc} onChange={setAcceptTc} />
      <Card className="py-2 px-4 !rounded-lg fixed bottom-0 left-0 w-full !shadow-[0px_-5px_10px_rgba(0,0,0,0.12)]">
        <StickyFooter
          data={subscription?.trade_by_pk}
          id={data.trade_by_pk?.id}
          userType={hashValue.userType}
          page={page}
          setPage={setPage}
        />
      </Card>
    </>
  ) : null
}
